import { TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { capitaliseText } from "../../../helpers/StringHelpers"
import NricValidator from "../../../services/validation/personal-and-contact-details-form/NricValidator"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"

function NricInputField(props: FormFieldProps<string>) {
    const { t } = useTranslation(`signup`)
    const { handleChange, errorText, defaultValue, isDisabled } = props
    const [helperText, setHelperText] = useState<string | undefined>()
    const [error, setError] = useState(false)

    const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        validateField(capitaliseText(event.target.value))
        handleChange(capitaliseText(event.target.value))
    }

    const validateField = (value: string) => {
        const validationText = (new NricValidator()).validate(value)
        setHelperText(validationText)
        setError(validationText !== undefined)
    }

    useEffect(() => {
        setError(errorText !== undefined)
        setHelperText(errorText ?? ``)
    }, [errorText, defaultValue])

    return (
        <TextField
            fullWidth
            id="nric-input"
            label={t(`nric`)}
            variant="outlined"
            margin="normal"
            value={defaultValue}
            error={error}
            helperText={helperText ? t(helperText) : ``}
            onChange={handleOnChange}
            onBlur={handleOnChange}
            inputProps={{ textTransform: `uppercase` }}
            disabled={isDisabled}
        />
    )
}

export default NricInputField